var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.send.apply(null, arguments)
        },
      },
    },
    [
      _vm.error
        ? _c(
            "div",
            {
              staticClass:
                "text-sm text-white text-center font-semibold bg-red mb-4 md:mb-7 p-1 rounded",
              attrs: { role: "alert" },
            },
            [_vm._v("\n    " + _vm._s(_vm.error) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-3 gap-2" }, [
        _c("div", { staticClass: "col-span-3 md:col-span-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.$v.email.$model,
                expression: "$v.email.$model",
              },
            ],
            staticClass: "input h-12",
            class: { "input--has-error": _vm.$v.email.$error },
            attrs: {
              id: "paint-calculator-email-input",
              "aria-describedby": "paint-calculator-email-input-error",
              type: "text",
              name: "email",
              placeholder: "name@mail.com",
            },
            domProps: { value: _vm.$v.email.$model },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.$v.email, "$model", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-span-3 md:col-span-1" }, [
          _c(
            "button",
            {
              staticClass: "btn-strong w-full h-12 cursor-pointer relative",
              attrs: { type: "submit", disabled: _vm.isLoading },
            },
            [
              _c(
                "span",
                {
                  staticClass: "transition-opacity duration-300",
                  class: { "relative opacity-0 z-10": _vm.isLoading },
                },
                [_vm._v("Submit")]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.isLoading
                  ? _c(
                      "div",
                      { staticClass: "absolute z-20" },
                      [
                        _c("LoaderSpinner", {
                          staticClass: "w-5 h-5 fill-white",
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center mb-4 md:mb-7" }, [
      _c(
        "label",
        {
          staticClass: "md:text-lg",
          attrs: { for: "paint-calculator-email-input" },
        },
        [_vm._v("Enter your email below")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }